import React, { useCallback, useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import socket from "../../../../api/socket";
import AppointmentDetailsModal from "./AppointmentDetailsModal";
import { statusStyles } from "./appointmentViewShared";

function AppointmentTr({ item, appointmStatus }: any) {
  const [select, setselect] = useState(item?.status);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setselect(item?.status);
  }, [item]);

  const handleChange = (e: any) => {
    setselect(e.target.value);
    socket.emit("allAppointmentStatus", {
      appointmentid: item?._id,
      status: e.target.value,
      queue: item?.queue,
      roomNumber: item?.roomNumber,
    });
    if (e.target.value === "ongoing" && item?.queue != null && item?.queue !== "") {
      try {
        localStorage.setItem("nextQueue", String(Math.max(0, Math.floor(Number(item.queue)))));
      } catch {
        /* ignore quota / private mode */
      }
    }
    baseUrl
      .patch(
        "/appointment/statusAppointmentById",
        {},
        {
          headers: { appointmentid: item?._id, status: e.target.value },
        }
      )
      .then(() => appointmStatus())
      .catch((error) => console.log(error));
  };

  const handleTreatmentClick = useCallback(
    (id: string, e: React.MouseEvent) => {
      e.stopPropagation();
      baseUrl
        .post("treatment/create-treatment", { patientId: id })
        .then((response) => {
          navigate(
            `/client/treatment-diagnose/add-treatment/diagnose/${response.data.data._id}`
          );
        })
        .catch((error) => console.error(error));
    },
    [navigate]
  );

  return (
    <tr className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors group">
      <td className="px-6 py-3 text-sm font-semibold text-slate-900 dark:text-slate-100">
        {item?.patientId?.fullName ? item?.patientId?.fullName : item?.bookPatientId?.fullName || "N/A"}
      </td>
      <td className="px-6 py-3 text-sm text-slate-700 dark:text-slate-200">
        {[item?.doctorId?.firstName, item?.doctorId?.lastName].filter(Boolean).join(" ").trim() || "—"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap">
        <div className="text-sm text-slate-600 dark:text-slate-300">
          {item?.date?.split("T")[0]}
        </div>
        <span className="mt-1 inline-block px-2.5 py-1 bg-primary/10 dark:bg-primary/30 text-primary dark:text-sky-300 rounded-md text-xs font-medium">
          {item?.startTime} - {item?.endTime}
        </span>
      </td>
      <td className="px-6 py-3 whitespace-nowrap">
        <div className="text-sm font-medium text-slate-800 dark:text-slate-100">
          {item?.sessionName || "—"}
        </div>
        <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-slate-600 dark:text-slate-300">
          <span>
            Room {String(item?.roomNumber ?? "").trim() || "—"}
          </span>
          <span className="text-slate-300 dark:text-slate-600">·</span>
          <span className="tabular-nums">
            Queue{" "}
            {item?.queue != null && item?.queue !== ""
              ? Number(item.queue)
              : "—"}
          </span>
        </div>
      </td>
      <td className="px-6 py-3">
        <select
          onChange={handleChange}
          value={select}
          className={`px-3 py-1.5 rounded-lg text-sm font-medium border cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/20 transition-colors ${
            statusStyles[select] || statusStyles.default
          }`}
        >
          <option value="">Select</option>
          <option value="appointment">Upcoming</option>
          <option value="completed">Completed</option>
          <option value="canceled">Canceled</option>
          <option value="inqueue">In Queue</option>
          <option value="ongoing">Ongoing</option>
          <option value="noshow">No Show</option>
        </select>
      </td>
      <td className="px-6 py-3 text-sm text-slate-700 dark:text-slate-200">
        {item?.purposeId?.purposeName || item?.bookTreatmentId?.name || "N/A"}
      </td>
      <td className="px-6 py-3">
        <span className={`px-2.5 py-1 rounded-md text-xs font-medium capitalize ${
          item?.type === "online" ? "bg-primary/10 dark:bg-primary/30 text-primary" : "bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300"
        }`}>
          {item?.type || "N/A"}
        </span>
      </td>
      <td className="px-6 py-3">
        <div className="flex gap-2 justify-center items-center">
          <button
            type="button"
            onClick={() => setDetailsOpen(true)}
            className="w-8 h-8 rounded-lg bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 flex items-center justify-center hover:bg-indigo-100 dark:hover:bg-indigo-900/60 active:bg-indigo-200 transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1"
            title="View appointment details"
            aria-label="View appointment details"
          >
            <RemoveRedEyeIcon sx={{ fontSize: 18 }} />
          </button>
          {item?.patientId?.fullName ? (
            <button
              type="button"
              onClick={(e: any) => handleTreatmentClick(item?.patientId?._id, e)}
              className="w-8 h-8 rounded-lg bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-300 flex items-center justify-center hover:bg-emerald-100 dark:hover:bg-emerald-900/60 active:bg-emerald-200 transition-all focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1"
              title="Add Treatment"
              aria-label="Add Treatment"
            >
              <MedicalInformationIcon sx={{ fontSize: 18 }} />
            </button>
          ) : (
            <span className="text-xs text-slate-400 dark:text-slate-500 italic">
              Patient not added
            </span>
          )}
        </div>
        <AppointmentDetailsModal
          item={item}
          open={detailsOpen}
          onClose={() => setDetailsOpen(false)}
          onStatusChange={appointmStatus}
        />
      </td>
    </tr>
  );
}

export default AppointmentTr;
